module.exports = __webpack_public_path__ + "img/lightLava.2ac26f55.jpg";